/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizzazioneResDto } from '../../models/organizzazione-res-dto';
import { UpdateOrganizzazioneDto } from '../../models/update-organizzazione-dto';

export interface OrganizzazioniControllerUpdateOrganizzazione$Params {
  idOrganizzazione: number;
  body: UpdateOrganizzazioneDto;
}

export function organizzazioniControllerUpdateOrganizzazione(
  http: HttpClient,
  rootUrl: string,
  params: OrganizzazioniControllerUpdateOrganizzazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<OrganizzazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    organizzazioniControllerUpdateOrganizzazione.PATH,
    'patch',
  );
  if (params) {
    rb.path('idOrganizzazione', params.idOrganizzazione, {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrganizzazioneResDto>;
      }),
    );
}

organizzazioniControllerUpdateOrganizzazione.PATH =
  '/admin/organizzazioni/id/{idOrganizzazione}';
